import React from 'react';
import { StyledLabel } from './StyledLabel';

interface AppInputLabelProps {
	label: React.ReactNode;
	focus: boolean;
	error?: boolean;
	name: string;
	required?: boolean;
}

export const AppInputLabel = ({ label, focus, error, name, required }: AppInputLabelProps) => {
	return (
		<StyledLabel
			style={{ fontWeight: focus ? 'bold' : '', textWrap: 'pretty' }}
			error={error}
			htmlFor={name}
			required={required}
		>
			{label}
		</StyledLabel>
	);
};
